import { PageHeader } from '@/components/layout/PageHeader';
import styles from '@/styles/pages/ComingSoonPage/style.scss';

export function ComingSoonPage({ title, message = 'This section is coming soon.' }: { title: string; message?: string }) {
  return (
    <>
      <PageHeader title={title} />
      <p className={styles.muted}>{message}</p>
    </>
  );
}
